import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'fcp-banner-texto-grande',
  templateUrl: './banner-texto-grande.component.html',
  styleUrls: ['./banner-texto-grande.component.scss']
})
export class BannerTextoGrandeComponent implements OnInit {
  @Input() public banner: any;

  public isDeviceDesktop: boolean;

  constructor() {
    this.checkDevice();
  }

  ngOnInit(): void {
  }

  private checkDevice() {
    if (window.innerWidth < 769) {
      this.isDeviceDesktop = false;
      return;
    }
    this.isDeviceDesktop = true;
  }

}
